import { useState, useEffect } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import { trackClick } from "../../utils/loadLandingTracking";
import "./Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [logo, setLogo] = useState("");
  const [supportPhone, setSupportPhone] = useState("+918735833046");

  const [nav, setNav] = useState({
    features: "Features",
    how: "How it works?",
    why: "Why us?",
    pricing: "Pricing",
  });

  const [demoBtn, setDemoBtn] = useState({
    text: "Request Demo",
    active: true,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();

      if (data?.company_logo) {
        if (typeof data.company_logo === "string") {
          setLogo(data.company_logo);
        } else if (data.company_logo?.value) {
          setLogo(data.company_logo.value);
        }
      }

      setNav({
        features: data?.nav_features?.value || data?.nav_features || "Features",
        how:
          data?.nav_how_it_works?.value ||
          data?.nav_how_it_works ||
          "How it works?",
        why: data?.nav_why_us?.value || data?.nav_why_us || "Why us?",
        pricing: data?.nav_pricing?.value || data?.nav_pricing || "Pricing",
      });

      if (data?.demo_buttton) {
        if (typeof data.demo_buttton === "string") {
          setDemoBtn({
            text: data.demo_buttton,
            active: true,
          });
        } else {
          setDemoBtn({
            text: data.demo_buttton.value || "Request Demo",
            active: data.demo_buttton.is_active === 1,
          });
        }
      }

      if (data?.company_favicon) {
        let faviconUrl = "";

        if (typeof data.company_favicon === "string") {
          faviconUrl = data.company_favicon;
        } else if (
          data.company_favicon.is_active === 1 &&
          data.company_favicon.value
        ) {
          faviconUrl = data.company_favicon.value;
        }

        if (faviconUrl) {
          let link =
            document.querySelector("link[rel='icon']") ||
            document.querySelector("link[rel='shortcut icon']");

          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }

          link.type = "image/png";
          link.href = faviconUrl;
        }
      }

      if (data?.support_phone) {
        if (typeof data.support_phone === "string") {
          setSupportPhone(data.support_phone);
        } else if (data.support_phone?.value) {
          setSupportPhone(data.support_phone.value);
        }
      }
    };

    fetchSettings();
  }, []);

  const handleDemoClick = () => {
    trackClick("header-book-demo-btn");
    const form = document.getElementById("demo-form");
    if (form) {
      form.scrollIntoView({ behavior: "smooth", block: "center" });
      form.classList.add("highlight-form");
      setTimeout(() => form.classList.remove("highlight-form"), 2500);
    }
    setOpen(false);
  };

  const handleCallClick = () => trackClick("header-call-btn", { category: "contact" });

  const handleNavClick = (elementId) => {
    trackClick(elementId, { category: "nav" });
    setOpen(false);
  };

  return (
    <header className="bg-white border-bottom sticky-top header-wrapper">
      <div className="container">
        <div className="d-flex align-items-center justify-content-between py-3">
          <div className="d-flex align-items-center gap-2">
            <a href="/" className="d-inline-flex align-items-center">
              <img
                src={logo || "/tele.png"}
                alt="Teleforce"
                height="32"
                style={{ cursor: "pointer" }}
              />
            </a>
          </div>

          <nav className="d-none d-lg-flex gap-4 fw-medium align-items-center">
            <a
              href="#features"
              className="nav-link"
              onClick={() => trackClick("header-nav-features", { category: "nav" })}
            >
              {nav.features}
            </a>
            <a
              href="#how"
              className="nav-link"
              onClick={() => trackClick("header-nav-how", { category: "nav" })}
            >
              {nav.how}
            </a>
            <a
              href="#why"
              className="nav-link"
              onClick={() => trackClick("header-nav-why", { category: "nav" })}
            >
              {nav.why}
            </a>
            <a
              href="#pricing"
              className="nav-link"
              onClick={() => trackClick("header-nav-pricing", { category: "nav" })}
            >
              {nav.pricing}
            </a>
          </nav>

          <div className="d-flex align-items-center gap-2">
            <a
              href={`tel:${supportPhone.replace(/\s+/g, "")}`}
              className="call-float-btn"
              onClick={handleCallClick}
            >
              <i className="bi bi-telephone-fill"></i>
            </a>

            {demoBtn.active && (
              <button
                className="btn btn-primary book-demo-btn"
                onClick={handleDemoClick}
              >
                {demoBtn.text}
              </button>
            )}

            <button
              className="btn btn-outline-primary menu-btn d-lg-none"
              onClick={() => setOpen(!open)}
            >
              <i className={`bi ${open ? "bi-x-lg" : "bi-list"}`}></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="mobile-nav d-lg-none">
            <a href="#features" onClick={() => handleNavClick("header-nav-features")}>
              {nav.features}
            </a>
            <a href="#how" onClick={() => handleNavClick("header-nav-how")}>
              {nav.how}
            </a>
            <a href="#why" onClick={() => handleNavClick("header-nav-why")}>
              {nav.why}
            </a>
            <a href="#pricing" onClick={() => handleNavClick("header-nav-pricing")}>
              {nav.pricing}
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
